import { INewsCreateUpdateItem } from '../../interfaces/news/INews';

export class LoadAllNews {
  static readonly type = '[News] LoadAllNews';
}

export class LoadAllActiveNews {
  static readonly type = '[News] LoadAllActiveNews';
}

export class LoadSingleNews {
  static readonly type = '[News] LoadSingleNews';
  constructor(public id: number) {}
}

export class CreateNews {
  static readonly type = '[News] CreateNews';
  constructor(public news: INewsCreateUpdateItem) {}
}
